<script setup>
const props = defineProps(['isOpen','width','title','subtitle','confirmButtonText', 'loading','errorMessage'])
const emit = defineEmits(['close','confirmClick'])

</script>

<template>
  <v-dialog
      :max-width="props.width ? props.width : '400'"
      :model-value="props.isOpen"
      @update:model-value="value => !value && emit('close')"
  >
    <v-card
        class="d-flex align-center py-5 px-5 ga-1"
        rounded
    >
      <div class="text-h5">{{props.title}}</div>
      <div class="text-grey-darken-1">{{props.subtitle}}</div>
      <div class="text-error"> {{props.errorMessage}} </div>
      <div class="d-flex flex-row ga-2 pt-7">
        <v-btn @click="emit('close')" color="primary" variant="text" rounded>{{ $t('gamification.cancel') }}</v-btn>
        <v-btn @click="emit('confirmClick')" :loading="loading" color="red-darken-2" variant="tonal" rounded>{{props.confirmButtonText}}</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>